import { Stack } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { colors } from "../utils/constant";
import { Link } from "react-router-dom";
import { getLanguage } from "../data/selector/language.selector";
import { useSelector } from "react-redux";

export default function Footer() {
  const Language = useSelector(getLanguage);
  return (
    <>
      <Box
        sx={{
          marginLeft: "55px",
          background: colors.headerBackgound,
          width: "100%",
          position: "fixed",
          bottom: 0,
          display: "flex",
          p: 2,
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Stack className="">{Language?.Footer?.copyRight}</Stack>
        <Stack
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          {/* <Link>{Language?.Footer?.terms}</Link> */}
          {/* <Box
            sx={{
              bgcolor: "black",
              height: "14px",
              width: "1px",
              border: "1px solid grey",
              mx: 1,
              my: 1,
            }}
          ></Box>
          <Link>{Language?.Footer?.privacy}</Link> */}
        </Stack>
        <Stack className="me-5">{Language?.Footer?.designed}</Stack>
      </Box>
    </>
  );
}
